// ACTION TYPES ($ means that the action updates the state)
const LOGIN_SUCCESS = 'analytics/LOGIN'
const SET_USER_ID = 'analytics/SET_USER_ID'
export const types = Object.freeze({
    LOGIN_SUCCESS,
    SET_USER_ID,
})
